'use client';
import React from 'react';
import SplideSlider from '@components/SplideSlider';
import { ImageObj } from '../../../../types/ImageObj.types';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Box, List, ListItem, ListItemText, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ParallaxBlock from '@components/ParallaxBlock';
import cn from './style.module.scss';

interface SpecificationTabDataProps {
  tabThemeImageBackground: any;
  tabs: Array<{
    heading: string;
    description: string;
    images: Array<ImageObj>;
    listElement: any;
    additional?: any;
  }>;
  t: any;
  layoutClass?: string;
}
const specificationTabDataSettings = {
  type: 'fade',
  rewind: true,
  autoplay: true,
  speed: 1000,
  perMove: 1,
  perPage: 1,
  start: 1,
};
export default function SpecificationTabData(props: SpecificationTabDataProps) {
  const { tabs, layoutClass = '', t } = props;
  const tabZero = 0;
  if (!tabs || tabs.length === 0) {
    return null;
  }
  function isObject(value: Record<string, any>) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }
  return (
    <Stack
      component="section"
      className={`${cn.wildsDataWrapper} ${cn[layoutClass]}`}
    >
      <Box component="article" className={cn.wildsSpecContent}>
        <Box component="div" className={cn.wildsDataHeading}>
          <h2>{ReactHtmlParser(tabs[tabZero].heading)}</h2>
          <p>{tabs[tabZero].description}</p>
        </Box>
        <Box component="div" className={cn.wildsDataBlock}>
          <List className={cn.wildsDataList}>
            {tabs[tabZero].listElement.col1.map((_: string, index: number) => (
              <>
                <ListItem>
                  {tabs[tabZero].listElement?.col1[index] && (
                    <span>{tabs[tabZero].listElement.col1[index]}</span>
                  )}
                  {tabs[tabZero].listElement?.col2 &&
                    tabs[tabZero].listElement?.col2[index] && (
                      <span>{tabs[tabZero].listElement?.col2[index]}</span>
                    )}
                </ListItem>
              </>
            ))}
          </List>
          {tabs[tabZero]?.additional ? (
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={700}
            >
              {tabs[tabZero].additional}
            </ParallaxText>
          ) : null}
        </Box>
      </Box>
      <Box component="picture" className={cn.wildsDataTheme}>
        <Box component="div" className={cn.wildsThemeElement}>
          {tabs[tabZero]?.images?.length > 1 ? (
            <SplideSlider options={specificationTabDataSettings}>
              {tabs[tabZero]?.images?.map((imgObj, index) => (
                <Box
                  className={cn.wildsStoryData}
                  key={`${imgObj.name}_${index}`}
                >
                  <img src={imgObj.url} alt={imgObj.alt} />
                </Box>
              ))}
            </SplideSlider>
          ) : (
            tabs[tabZero]?.images?.length > 0 && (
              <Box className={cn.wildsStoryData}>
                <img
                  src={tabs[tabZero].images[0].url}
                  alt={tabs[tabZero].images[0].alt}
                />
              </Box>
            )
          )}
        </Box>
        <Box
          component="div"
          className={cn.wildsThemeGraphics}
          sx={{
            backgroundImage: `url(${props.tabThemeImageBackground.url})`,
          }}
        />
      </Box>
    </Stack>
  );
}
